    import moment from "moment";

    export default {
        setPicker(
            inputElement,
            dateFormat = "MMMM D",
            withRange = false,
            withTime = false,
            autoUpdate = null,
        ) {
            if (inputElement.length === 0)
                return;

            // Check if daterangepicker is already initialized
            if (inputElement.data('daterangepicker')) {
                // Destroy existing instance before reinitializing
                inputElement.data('daterangepicker').remove();
            }

            let $this = this;

            autoUpdate = autoUpdate ?? !withRange;
            let singleDatePicker = !withRange;

            // Determine if we're in a sidebar or modal context
            let modalDialog = inputElement.closest('.modal-dialog');
            let rightSidebar = inputElement.closest('.right-sidebar');
            let isInModal = modalDialog.length > 0;
            let isInSidebar = rightSidebar.length > 0;
            
            let pickerOptions = {
                autoUpdateInput: autoUpdate,
                singleDatePicker: singleDatePicker,
                timePicker: withTime,
                locale: {
                    format: dateFormat,
                    firstDay: 1
                },
                drops: 'auto',
                opens: 'left'
            };
            
            // If in modal, set parentEl to modal-content and force calendar to open downward to avoid clipping/overlap
            if (isInModal) {
                let modalContent = inputElement.closest('.modal-content');
                if (modalContent.length > 0) {
                    pickerOptions.parentEl = modalContent[0]; // Convert jQuery to DOM element
                } else if (modalDialog.length > 0) {
                    pickerOptions.parentEl = modalDialog[0]; // Fallback to modal-dialog
                }
                pickerOptions.drops = 'down'; // Open below input so calendar is not cut off or overlapping modal header
            } else if (isInSidebar) {
                // If in sidebar, set parentEl to position relative to the sidebar
                if (rightSidebar.length > 0) {
                    pickerOptions.parentEl = rightSidebar[0]; // Convert jQuery to DOM element
                }
            }

            inputElement.daterangepicker(pickerOptions);

            let picker = inputElement.data('daterangepicker');
            let pickerContainer = picker.container;

            // Special handling for cockpit statistics page
            let isOnStatisticsPage = window.location.pathname.includes('/cockpit/statistics');
            let isInLogsModal = inputElement.closest('#logs_modal').length > 0;
            
            if (isOnStatisticsPage && isInLogsModal) {
                // Apply special styles for statistics page
                let applyStatisticsStyles = function(container) {
                    if (container && container.length > 0 && container[0]) {
                        container.css({
                            'width': '100%',
                            'position': 'absolute'
                        });
                        // Use setProperty for !important
                        container[0].style.setProperty('top', '0', 'important');
                    }
                };
                
                // Apply styles when picker is shown
                inputElement.on('show.daterangepicker', function(ev, picker) {
                    applyStatisticsStyles(picker.container);
                });
                
                // Also apply immediately if picker is already shown
                if (pickerContainer && pickerContainer.length > 0 && pickerContainer.is(':visible')) {
                    applyStatisticsStyles(pickerContainer);
                }
                
                // Apply styles when modal is opened (in case picker is initialized before modal opens)
                $('#logs_modal').on('shown.bs.modal', function() {
                    let picker = inputElement.data('daterangepicker');
                    if (picker && picker.container) {
                        applyStatisticsStyles(picker.container);
                    }
                });
            }

            // Add event handler to update input value when date is selected
            inputElement.on('apply.daterangepicker', function(ev, picker) {
                let selectedDate;
                if (withTime) {
                    selectedDate = picker.startDate.format(dateFormat);
                } else {
                    if (withRange) {
                        selectedDate = picker.startDate.format(dateFormat) + ' - ' + picker.endDate.format(dateFormat);
                    } else {
                        selectedDate = picker.startDate.format(dateFormat);
                    }
                }
                $(this).val(selectedDate);
            });

            let mobileCalendar = $('.mobile-menu').length > 0 ? $('.mobile-menu').css('display') !== "none" : false;

            if (withRange) {
                if (mobileCalendar) {
                    let rangeSelect = $('#daterangepicker_range_select_template').html();
                    pickerContainer.find('.drp-buttons').prepend(rangeSelect);

                    pickerContainer.find('.drp-selected').addClass('d-none');
                    pickerContainer.find('.drp-calendar.left').css('padding-top', '0px');

                    $this.initRangeSelect(inputElement, picker, dateFormat);
                } else {
                    let rangeButtons = $('#daterangepicker_range_buttons_template').html();
                    pickerContainer.find('.drp-calendar.left').before(rangeButtons);

                    $this.initRangeButtons(inputElement, picker, dateFormat);
                }
            } else {
                $this.initResetButtomForSingleDate(inputElement, picker, dateFormat);
            }

            if (mobileCalendar) {
                $this.initDateClickedObserver(pickerContainer);
                $this.initShowCalendarEventForMobile(inputElement);
                $this.updatePickerPositionForMobile(pickerContainer);
            }
            return picker
        },

        updatePickerPositionForMobile(pickerContainer) {
            let previousPickerTop = null;

            let styleObserver = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        let pickerTop = pickerContainer.offset().top;


                        if (pickerTop !== previousPickerTop) {
                            previousPickerTop = pickerTop;

                            let displayHeight = $(window).height();
                            let pickerHeight = pickerContainer.height();

                            if (pickerHeight + pickerTop > displayHeight) {
                                var neededTop = displayHeight - pickerHeight;
                                pickerContainer.css('top', neededTop - 10 + "px");
                            }
                        }
                    }
                }
            });

            styleObserver.observe(pickerContainer[0], {
                attributes: true,
                attributeFilter: ['style'],
                attributeOldValue: true
            });

        },

        initResetButtomForSingleDate(inputElement, picker, dateFormat) {
            let $this = this;
            let currentData = moment().startOf('day').format(dateFormat);
            let dates = {
                startDate: currentData,
                endDate: currentData,
            }

            let resetButton = picker.container.find('.cancelBtn');

            resetButton.on('click', function() {
                $this.setRangeActionToButton(inputElement, picker, dates);
            });
        },

        initRangeButtons(inputElement, picker, dateFormat) {
            let $this = this;

            picker.container.find('.range-button').each(function() {
                let rangeType = $(this).data('range_type');
                let rangeDates = $this.getRangeDates(rangeType, dateFormat);

                $(this).on('click', function() {
                    $this.setRangeActionToButton(inputElement, picker, rangeDates)
                });
            });
        },

        initRangeSelect(inputElement, picker, dateFormat) {
            let select = picker.container.find('.range-select');
            let $this = this;

            select.on('change', function() {
                let rangeType = $(this).val();
                let rangeDates = $this.getRangeDates(rangeType, dateFormat);

                $this.setRangeActionToButton(inputElement, picker, rangeDates);
            });
        },

        getRangeDates(rangeType, dateFormat) {
            let rangeData = rangeType.split('_');
            let isPreviousYear = rangeData[0] === "last";
            let range = rangeData[1];

            let startDate = moment();
            let endDate = moment();

            if (isPreviousYear) {
                startDate = startDate.subtract(1, range);
                endDate = endDate.subtract(1, range);
            }

            startDate = startDate.startOf(range).format(dateFormat);
            endDate = endDate.endOf(range).format(dateFormat);

            return {
                startDate: startDate,
                endDate: endDate,
            };
        },

        setRangeActionToButton(inputElement, picker, rangeDates) {
            inputElement.val(rangeDates.startDate + " - " + rangeDates.endDate);
            picker.setStartDate(rangeDates.startDate);
            picker.setEndDate(rangeDates.endDate);
            picker.updateElement();
            picker.hide();
            picker.show();
        },

        initDateClickedObserver(pickerContainer) {
            let $this = this;

            let observer = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        let target = mutation.target;

                        if (
                            target.classList.contains('active')
                            && target.classList.contains('start-date')
                            && target.classList.contains('available')
                            && target.classList.contains('in-range')
                        ) {
                            $this.addNextMonthButton(pickerContainer);
                        }
                    }
                }
            });

            observer.observe(pickerContainer[0], {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });
        },

        initShowCalendarEventForMobile(inputElement) {
            let $this = this;

            inputElement.on('showCalendar.daterangepicker', function(ev, clickedPicker) {

                $this.updateDateButtonStyles(clickedPicker.container);
                $this.addNextMonthButton(clickedPicker.container);
            });


            function debounce(fn, wait = 0) {
                let t;
                return function (...args) {
                    clearTimeout(t);
                    t = setTimeout(() => fn.apply(this, args), wait);
                };
            }

            inputElement.on('showCalendar.daterangepicker', function (ev, picker) {
                const container = picker.container;
                const leftCalendar = container.find('.drp-calendar.left')[0] || container.find('.drp-calendar').get(0);
                if (!leftCalendar) {
                    return;
                }

                const onChange = debounce(function (mutationsList) {
                    $(leftCalendar).find('.table-condensed tbody td').css('font-size', '16px');
                    $this.addNextMonthButton(container);
                }, 0);

                const observerConfig = {
                    childList: true,
                    subtree: true,
                    characterData: true
                };

                const observer = new MutationObserver(function (mutationsList) {
                    onChange(mutationsList);
                });

                observer.observe(leftCalendar, observerConfig);
            });
        },

        updateDateButtonStyles(pickerContainer) {
            pickerContainer.find('.drp-calendar.right').css('display', 'none');
            let leftCoord = pickerContainer.offset().left + "px";
            pickerContainer[0].style.setProperty('width', 'calc(100% - ' + leftCoord, 'important');

            pickerContainer.find('.drp-calendar').css({
                'width': '100%',
                'max-width': 'none',
            });

            pickerContainer.find('.table-condensed tbody td').css('font-size', '16px');
        },

        addNextMonthButton(pickerContainer) {
            let leftCalendarHeader = pickerContainer
                .find('.drp-calendar.left .table-condensed thead tr')
                .first();

            let nextButton = $('#daterangepicker_next_month_button').html();
            leftCalendarHeader.find("th")[2].remove();
            leftCalendarHeader.append(nextButton);
        },

    }
